<script lang="ts">
  export let playerId: string | undefined = undefined;
  export let mediaSessionId: string | undefined = undefined;
  export let errorCode: number | undefined = undefined;
</script>

<div class="error-layer" role="alert">
  <p class="error-heading">Medium konnte nicht geladen werden</p>

  {#if mediaSessionId || playerId || errorCode}
    <dl class="error-details">
      {#if errorCode}
        <div class="detail">
          <dt class="detail-term">Fehlercode:</dt>
          <dd class="detail-description">{errorCode}</dd>
        </div>
      {/if}

      {#if playerId}
        <div class="detail">
          <dt class="detail-term">Player-Id:</dt>
          <dd class="detail-description">{playerId}</dd>
        </div>
      {/if}

      {#if mediaSessionId}
        <div class="detail">
          <dt class="detail-term">Session-Id:</dt>
          <dd class="detail-description">{mediaSessionId}</dd>
        </div>
      {/if}
    </dl>
  {/if}
</div>

<style module>
  .error-layer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.5em;
    padding: clamp(0.5em, 1cqw + 0.25em, 1em);
    background-color: #000000;
    background-color: var(--error-layer-background-color);
    color: #ffffff;
    color: var(--error-layer-color);
  }

  .error-heading {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: clamp(1em, 1.5cqw + 0.6em, 1.5em);
    font-weight: 700;
    text-align: center;
    text-shadow: 1px 1px 2px #000000;
    margin: 0;
  }

  .error-details {
    /* 12px@320px, 16px@640px */
    font-size: clamp(0.75em, 1.25cqw + 0.5em, 1em);
    align-self: baseline;
    display: flex;
    flex-wrap: wrap;
    gap: 0 0.5em;
    color: grey;
    margin: 0;
  }

  .detail {
    display: flex;
    gap: 0.125em;
  }

  .detail-term {
    font-weight: 700;
  }

  .detail-description {
    margin-left: 0;
  }
</style>
